import { CIcon } from '~/icons/types'

export const ciTechnologySecurity: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M16.522 1.5H7.478a2.5 2.5 0 0 0-2.5 2.5v16a2.5 2.5 0 0 0 2.5 2.5h9.044a2.5 2.5 0 0 0 2.5-2.5V4a2.5 2.5 0 0 0-2.5-2.5Zm1.5 18.5a1.5 1.5 0 0 1-1.5 1.5H7.478a1.5 1.5 0 0 1-1.5-1.5v-.977h12.044V20Zm0-1.977H5.978V4a1.5 1.5 0 0 1 1.5-1.5h9.044a1.5 1.5 0 0 1 1.5 1.5v14.023Z'
    },
    {
      d:
        'M14.173 3.238H9.826a.5.5 0 1 0 0 1h4.347a.5.5 0 1 0 0-1ZM12 20.934a.718.718 0 1 0 0-1.436.718.718 0 0 0 0 1.436Zm0-1a.283.283 0 1 1 0 .566.283.283 0 0 1 0-.566Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'technology-security',
  type: 'thin'
}
